import React, { Component } from 'react';

class Fblogin extends Component {

    componentDidMount() {
        window.fbAsyncInit = () => {
            window.FB.init({
              appId      : process.env.REACT_APP_FACEBOOK_APP_ID,
              cookie     : true,  // enable cookies to allow the server to access
                                // the session
              xfbml      : true,  // parse social plugins on this page
              version    : 'v3.3' // use version 2.1
            });
        }

        // Load the SDK asynchronously
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
        
    }

    _handleClick() {
        const self = this
        window.FB.login(response => {
            if (response.authResponse) {
                // console.log('Welcome!  Fetching your information.... ');
                window.FB.api('/me?fields=id,name,picture', function(response) {
                    // console.log('Good to see you', response );
                    self.props.callback(response)
                });
            } else {
                console.log('User cancelled login or did not fully authorize.');
            }
        });
    }

    render() { 
        return ( 
            <div className="fb-login" onClick={()=>this._handleClick()}></div>
        );
    }
}
 
export { Fblogin }